import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getTimeKeepingManagerDetailStart,
  getTimeKeepingManagerDetailSuccess,
  getTimeKeepingManagerDetailFailed,
} from "../redux/getTimeKeepingManagerDetail";

import { toast } from "react-toastify";
import { getTimeKeepingManagerDetailAPI } from "core/http/service/timeKeeping";
import { SCREEN } from "helper/roleChecker/Screens";
import { ErrorMessage } from "core/http/service/decleareLeave/const";

function* getTimeKeepingManagerDetailWork(action) {
  try {
    const res = yield call(getTimeKeepingManagerDetailAPI, {
      ...action.payload,
      screenCode: SCREEN.IP_019,
    });

    yield put({
      type: getTimeKeepingManagerDetailSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: getTimeKeepingManagerDetailFailed.type,
    });
  }
}

function* watchGetTimeKeepingManagerDetail() {
  yield takeLatest(
    getTimeKeepingManagerDetailStart.type,
    getTimeKeepingManagerDetailWork
  );
}

export default function* getTimeKeepingManagerDetailSaga() {
  yield all([watchGetTimeKeepingManagerDetail()]);
}
